/**
 * Returns the dashboard path based on user role.
 * Normalizes role to lowercase before matching.
 */
export function getDashboardPath(role) {
  const r = (role || '').toLowerCase();
  switch (r) {
    case 'admin':
      return '/admin';
    case 'editor':
      return '/editor/dashboard';
    case 'reporter':
      return '/reporter/dashboard';
    case 'volunteer':
    case 'contributor':
    case 'public':
    default:
      return '/';
  }
}
